import { AdTemplate } from "../AdTemplate";

export class AdTemplateUpdateRequest extends AdTemplate {
    id!: string;
}